import * as React from 'react';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import NavigationBar from '../components/navigationBar';
import { bannerData, navigationData, aboutData, contactFormData, contactDetails, serviceData, pricingheadingText, pricingSubHeadingText, pricingPlans, teamMembers } from '../assets/data/Data';
import { logoImage, bannerImage, contactImage, aboutImage } from '../assets/data/Images';
import itlogo from "../assets/images/CO-LOGO.png"
import AboutCards from '../components/aboutCard';
import ContactUs from '../components/ContactCard';
import BannerCard from '../components/bannerCard';
import Content from '../components/Content';
import ChatPopUp from '../components/chatPopUp';
import TeamSection from "../components/teamCard"
import Pricing from '../components/Pricing';
import FooterCard from "../components/footerCard";
import { footerData } from "../assets/data/Data";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import BusinessToolCards from '../Util/UtilCategoryCard/UtilCategoryCard';
import UtilHeader from '../Util/UtilHeader/UtilHeader';
import ArticlePage from "./articlePage/ArticlePage";
import SidebarWithContent from "./documentPage/documentPage";
import ScrollToTop from '../components/ScrollToTop';
export default function ServiceTemplate() {
    const isMobile = useMediaQuery('(max-width:768px)');
    const [drawerOpen, setDrawerOpen] = React.useState(false);
    const navigate=useNavigate();
    const location = useLocation();
    const toggleDrawer = (open) => () => {
        setDrawerOpen(open);
    };
  const handleScroll = (id) => {
    console.log("Scrolling to ID:", id);
    const element = document.getElementById(id);
    if (location.pathname !== "/" && id !== "knowledgebase") {
      // Navigate to homepage first
      navigate("/");
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        const targetElement = document.getElementById(id);
        if (targetElement) {
          const yOffset = -80;
          const y = targetElement.getBoundingClientRect().top + window.scrollY + yOffset;
          window.scrollTo({ top: y, behavior: "smooth" });
        } else {
          console.log("Element not found after navigation:", id);
        }
      }, 100); // Small delay to ensure DOM is updated
    } else if (element) {
      const yOffset = -80;
      const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    } else {
      console.log("Element not found:", id);
    }
  };
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box id="nav">
                <NavigationBar
                    logo={itlogo}
                    isMobile={isMobile}
                    drawerOpen={drawerOpen}
                    toggleDrawer={toggleDrawer}
                    handleScroll={handleScroll}
                    navigationData={navigationData}
                />
                {location.pathname !== '/' && <UtilHeader />}
            </Box>
            <ScrollToTop/>
            <Routes>
                <Route
                    path="/"
                    element={
                        <>
                            <Box id="Home" >
                                <BannerCard isMobile={isMobile} banner={bannerImage} bannerData={bannerData} />
                            </Box>

                            <Box id="Service" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 5 }}>

                                <AboutCards data={serviceData} isMobile={isMobile} isHeading={true} />
                            </Box>
                            <Box id="About" sx={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', padding: 2, mt: 2 }} ml={!isMobile ? 5 : 0}>
                                <Content
                                    isMobile={isMobile}
                                    data={aboutData}
                                    image={aboutImage}
                                />
                            </Box>
                            {/* <Box  id="Pricing">
            <Pricing headingText={pricingheadingText} subHeadingText={pricingSubHeadingText} pricingPlans={pricingPlans} />
          </Box> */}
                            {/* About Section */}
                            <Box id="Team" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 5 }}>
                                <TeamSection data={teamMembers} isMobile={isMobile} />
                            </Box>
                            <Box id="Contact">
                                <ContactUs image={contactImage} data={contactDetails} formData={contactFormData} />

                            </Box>

                        </>
                    } />
                <Route path="/knowledgebase" element={<BusinessToolCards />} />
                <Route path="/knowledgebase/article/:search/:id" element={<ArticlePage />} />
                <Route path="/knowledgebase/document/:recordid" element={<SidebarWithContent />} />
            </Routes>
            <Box id="footer">
                <FooterCard footerData={footerData} />
                <ChatPopUp />
            </Box>
        </Box>
    );
}
